import { actionTypes } from 'store/utils';

export const types = {
  ...actionTypes('CHECK_LOGGED_USER'),
  ...actionTypes('GET_USER'),
  ...actionTypes('UPDATE_USER'),
  ...actionTypes('LOGIN_USER'),
  ...actionTypes('AUTHENTICATE_USER'),
  ...actionTypes('GET_ACCOUNT'),
  ...actionTypes('ASK_USER_TEMP_PASSWORD'),
  ...actionTypes('SET_USER_NEW_PASSWORD'),
  RESET_USER: 'RESET_USER',
};
